var _path, _path2, _path3, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 91,
    viewBox: "0 0 141 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.712 10.0138C136.712 16.6896 127.546 24.2 127.546 24.2C127.546 24.2 118.379 16.6896 118.379 10.0138C118.379 4.92344 122.462 0.834473 127.546 0.834473C132.629 0.834473 136.712 4.92344 136.712 10.0138Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.548 15.8551C130.77 15.8551 133.382 13.2398 133.382 10.0137C133.382 6.78764 130.77 4.17236 127.548 4.17236C124.327 4.17236 121.715 6.78764 121.715 10.0137C121.715 13.2398 124.327 15.8551 127.548 15.8551Z",
    fill: "#3B3B3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.547 12.5172C128.928 12.5172 130.047 11.3963 130.047 10.0137C130.047 8.63109 128.928 7.51025 127.547 7.51025C126.166 7.51025 125.047 8.63109 125.047 10.0137C125.047 11.3963 126.166 12.5172 127.547 12.5172Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2810_8202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6986 70.5684C26.6986 78.7232 16.0427 87.8975 16.0427 87.8975C16.0427 87.8975 5.38672 78.7232 5.38672 70.5684C5.38672 64.3503 10.1335 59.3555 16.0427 59.3555C21.9519 59.3555 26.6986 64.3503 26.6986 70.5684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2810_8202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2534 65.5986H18.0201C17.8839 65.5986 17.7734 65.7096 17.7734 65.8464V65.8756L19.5001 67.263V65.8464C19.5001 65.7096 19.3897 65.5986 19.2534 65.5986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4297 68.8196C15.4297 68.4775 15.7058 68.2002 16.0464 68.2002C16.3869 68.2002 16.663 68.4775 16.663 68.8196C16.663 69.1617 16.3869 69.439 16.0464 69.439C15.7058 69.439 15.4297 69.1617 15.4297 68.8196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3621 69.5436L20.7477 69.8534C20.9073 69.9816 21.1401 69.9556 21.2677 69.7953C21.3954 69.6351 21.3695 69.4012 21.2099 69.2729L17.2012 66.0517C16.5255 65.5088 15.5655 65.5088 14.8898 66.0517L10.8811 69.2729C10.7215 69.4012 10.6956 69.6351 10.8233 69.7953C10.9509 69.9556 11.1838 69.9816 11.3433 69.8534L11.7289 69.5436V74.6423H11.1122C10.9079 74.6423 10.7422 74.8087 10.7422 75.0139C10.7422 75.2191 10.9079 75.3855 11.1122 75.3855H20.9788C21.1831 75.3855 21.3488 75.2191 21.3488 75.0139C21.3488 74.8087 21.1831 74.6423 20.9788 74.6423H20.3621V69.5436ZM14.6888 68.8199C14.6888 68.0673 15.2962 67.4572 16.0455 67.4572C16.7948 67.4572 17.4021 68.0673 17.4021 68.8199C17.4021 69.5725 16.7948 70.1826 16.0455 70.1826C15.2962 70.1826 14.6888 69.5725 14.6888 68.8199ZM16.0699 70.6781C16.3979 70.6781 16.6805 70.678 16.9068 70.7086C17.1493 70.7414 17.3818 70.8153 17.5704 71.0046C17.759 71.1941 17.8325 71.4276 17.8651 71.6712C17.8936 71.8843 17.8954 72.1471 17.8955 72.4506C17.8955 72.4708 17.8955 72.4913 17.8955 72.5118V74.6423H17.1555V72.5363C17.1555 72.1754 17.1547 71.9421 17.1317 71.7702C17.1101 71.609 17.0753 71.5585 17.0471 71.5302C17.019 71.5019 16.9687 71.467 16.8082 71.4453C16.637 71.4222 16.4048 71.4214 16.0455 71.4214C15.6862 71.4214 15.4539 71.4222 15.2828 71.4453C15.1224 71.467 15.0721 71.5019 15.0439 71.5302C15.0157 71.5585 14.9809 71.609 14.9593 71.7702C14.9363 71.9421 14.9355 72.1754 14.9355 72.5363V74.6423H14.1955V72.5118C14.1955 72.1824 14.1955 71.8985 14.2259 71.6712C14.2585 71.4276 14.332 71.1941 14.5206 71.0046C14.7092 70.8153 14.9417 70.7414 15.1842 70.7086C15.4105 70.678 15.6932 70.6781 16.0212 70.6781H16.0699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4297 68.8196C15.4297 68.4775 15.7058 68.2002 16.0464 68.2002C16.3869 68.2002 16.663 68.4775 16.663 68.8196C16.663 69.1617 16.3869 69.439 16.0464 69.439C15.7058 69.439 15.4297 69.1617 15.4297 68.8196Z",
    fill: "white"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5625 86.4826H37.6761V38.0952H99.3607V51.036H127.926V18.9653",
    stroke: "white",
    strokeDasharray: "2 2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2810_8202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.0606,
    height: 31.1034,
    fill: "white",
    transform: "translate(0.652344 59.1724)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2810_8202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.8399,
    height: 11.8925,
    fill: "white",
    transform: "translate(10.125 64.1123)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.07cd8f97de1da72d69744bf8b938c75b.svg";
export { ForwardRef as ReactComponent };